var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { createGlobalStyle, css } from "styled-components";
import { createFontFaces } from "../../fonts/utils";
import ProximaNovaFontDef from "../../fonts/proxima-nova";
import * as typography from "../../typography";
import { bonfireGet } from "../../theme";
var typographyStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  body {\n    ", ";\n    color: ", ";\n  }\n\n  h1 {\n    ", ";\n  }\n\n  h2 {\n    ", ";\n  }\n\n  h3 {\n    ", ";\n  }\n\n  h4 {\n    ", ";\n  }\n\n  h5 {\n    ", ";\n  }\n\n  label {\n    ", ";\n  }\n\n  legend {\n    ", ";\n  }\n"], ["\n  body {\n    ", ";\n    color: ", ";\n  }\n\n  h1 {\n    ", ";\n  }\n\n  h2 {\n    ", ";\n  }\n\n  h3 {\n    ", ";\n  }\n\n  h4 {\n    ", ";\n  }\n\n  h5 {\n    ", ";\n  }\n\n  label {\n    ", ";\n  }\n\n  legend {\n    ", ";\n  }\n"])), typography.body, bonfireGet("colors", "textDark"), typography.h1, typography.h2, typography.h3, typography.h4, typography.h5, typography.label, typography.legend);
var FontFacesStyle = createGlobalStyle(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n\n  ", ";\n"], ["\n  ", ";\n\n  ", ";\n"])), function (props) { return createFontFaces(ProximaNovaFontDef, props.fontResolver); }, function (props) { return props.applyGlobalStyles && typographyStyles; });
var FontFaces = function (props) { return (React.createElement(FontFacesStyle, __assign({ applyGlobalStyles: false }, props))); };
export default FontFaces;
var templateObject_1, templateObject_2;
//# sourceMappingURL=FontFaces.js.map